import { Type } from '@angular/core';
import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { MdIconModule } from '@angular/material';

import { TdMessageComponent, TdMessageContainerDirective } from './message.component';

const /** @type {?} */ TD_MESSAGE: Type<any>[] = [
  TdMessageComponent,
  TdMessageContainerDirective,
];

export { TdMessageComponent } from './message.component';
export class QuiverMessageModule {

static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    MdIconModule,
  ],
  declarations: [
    TD_MESSAGE,
  ],
  exports: [
    TD_MESSAGE,
  ],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function QuiverMessageModule_tsickle_Closure_declarations() {
/** @type {?} */
QuiverMessageModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
QuiverMessageModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
